export const formatearFecha = (fechaIso) => {
  if (!fechaIso) return '-';
  const [anio, mes, dia] = fechaIso.split('-');
  return `${dia}/${mes}/${anio}`;
};

const DIAS_SEMANA_CORTOS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

// "Lun 24". Calcula el día de semana en UTC a partir de los componentes de
// la fecha (mismo criterio que diasDesde() en el backend) para no arrastrar
// el desfase horario del huso local — new Date('YYYY-MM-DD') lo interpreta
// en UTC y puede mostrar el día de semana equivocado según la hora local.
export const formatearFechaCorta = (fechaIso) => {
  if (!fechaIso) return '-';
  const [anio, mes, dia] = fechaIso.split('-').map(Number);
  const diaSemana = DIAS_SEMANA_CORTOS[new Date(Date.UTC(anio, mes - 1, dia)).getUTCDay()];
  return `${diaSemana} ${dia}`;
};

// CUIT/CUIL a formato XX-XXXXXXXX-X, solo para mostrar/imprimir (nunca se
// toca el dato guardado). Se queda con los dígitos y aplica la máscara solo
// si son exactamente 11 — si el dato está mal cargado (menos/más dígitos, o
// ya trae guiones raros), devuelve el valor tal cual vino, sin forzar nada.
export const formatearCuil = (valor) => {
  if (!valor) return valor;
  const digitos = String(valor).replace(/\D/g, '');
  if (digitos.length !== 11) return valor;
  return `${digitos.slice(0, 2)}-${digitos.slice(2, 10)}-${digitos.slice(10)}`;
};

// Se queda solo con los dígitos de un CUIL (ignora guiones/puntos/espacios,
// sea de tipear o de pegar un valor ya formateado) y corta en 11 — es lo
// único que se guarda en el estado del formulario y lo que se manda al
// backend; el formato con guiones es puramente de exhibición en el input.
export const soloDigitosCuil = (valor) => String(valor || '').replace(/\D/g, '').slice(0, 11);

// Máscara EN VIVO para el input de CUIL/CUIT (a diferencia de formatearCuil,
// que es solo para mostrar un valor ya completo): toma los dígitos ya
// limpios (ver soloDigitosCuil) y va insertando los guiones a medida que
// hay dígitos suficientes (XX / XX-XXXXXXXX / XX-XXXXXXXX-X).
export const enmascararCuil = (valor) => {
  const digitos = soloDigitosCuil(valor);
  if (digitos.length <= 2) return digitos;
  if (digitos.length <= 10) return `${digitos.slice(0, 2)}-${digitos.slice(2)}`;
  return `${digitos.slice(0, 2)}-${digitos.slice(2, 10)}-${digitos.slice(10)}`;
};

// Recalcula dónde debe quedar el cursor después de reformatear el input de
// CUIL, para que borrar/escribir en el medio del valor no lo mande siempre
// al final. Cuenta cuántos dígitos había antes del cursor en el valor
// crudo (pre-formateo) y ubica el cursor después de esa misma cantidad de
// dígitos en el valor ya formateado (los guiones no cuentan).
export const posicionCursorCuil = (valorCrudo, cursorPrevio, valorFormateado) => {
  const digitosPrevios = String(valorCrudo).slice(0, cursorPrevio).replace(/\D/g, '').length;
  if (digitosPrevios === 0) return 0;
  let vistos = 0;
  for (let i = 0; i < valorFormateado.length; i++) {
    if (/\d/.test(valorFormateado[i])) vistos++;
    if (vistos === digitosPrevios) return i + 1;
  }
  return valorFormateado.length;
};
